import { Resource } from '../../../http/resource/resource.model';

export class HttpMethods extends Resource {
  title: string;
}
